import { Component } from "@angular/core";
import { RouterModule } from "@angular/router";
import { HeaderComponent } from "./header/header.component";

@Component({
	selector: "app-layout",
	standalone: true,
	imports: [RouterModule, HeaderComponent],
	templateUrl: "./layout.component.html",
	styleUrls: ["./layout.component.scss"],
})
export class LayoutComponent {}
